import React, { useContext, useEffect, useRef, useState } from "react";
import { fmDataContext } from "../../Context/FmData";
import Pagination from "../Pagination/Pagination";
import { Link } from "react-router-dom";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import LabelRow from "./LabelRow";
import LoadingCircle from "../LoadingCircle/LoadingCircle";
import { fmLabelsContext } from "../../Context/LabelsContext";
import userCan from "../../helpers/userCan";
import { toast } from "react-toastify";
import LabelsFiltration from "./LabelsFiltration";

const Labels = () => {
  const isCalledRef = useRef(false);

  let { baseUrl, navigate, getData } = useContext(fmDataContext);

  let [labels, setLabels] = useState({});

  let [isGetLabelsLoading, setIsGetLabelsLoading] = useState(true);

  let [isPaginateLoading, setIsPaginateLoading] = useState(false);

  let [pageNum, setPageNum] = useState(1);

  let perPage = 20;
  let orderBy = "id";
  let orderType = "asc";

  let { labelMsg, setLabelMsg, filtrationDetails, isFiltrationLoading, setFiltrationDetails } = useContext(fmLabelsContext);

  const getLabels = (reqMethod, pathName, params, setLoading = setIsGetLabelsLoading, message = null) => {
    getData(reqMethod, pathName, params, setLoading)
      .then((response) => {
        response.data.data.forEach((label) => {
          // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
          // if (label.label_image.includes("via.placeholder.com")) {
          //   label.label_image = label.label_image.replace("http://127.0.0.1:8000/storage/", "");
          // }
          // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
        });
        setLabels(response.data);
        setLoading(false);
        if (labelMsg.length > 0) {
          toast(labelMsg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            progressStyle: { backgroundColor: "#fdb915" },
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "dark",
            onClose: () => setLabelMsg(""),
          });
        }
        if (message) {
          toast(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            progressStyle: { backgroundColor: "#fdb915" },
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        }
      })
      .catch((error) => {
        navigate("/not-found");
      });
  };

  useEffect(() => {
    if (!isCalledRef.current) {
      getLabels(
        "GET",
        `${baseUrl}fm-labels`,
        {
          page_num: pageNum,
          per_page: perPage,
          order_type: orderType,
          order_by: orderBy,
        },
        setIsGetLabelsLoading
      );
    }

    return () => {
      isCalledRef.current = true;
      setFiltrationDetails({
        search_query: "",
        only_trashed: 0,
      });
    };
  }, []);

  return (
    <div className="container">
      <div className={`${!isGetLabelsLoading ? "min-vh-100" : ""}`}>
        {isGetLabelsLoading ? (
          <LoadingScreen />
        ) : (
          <>
            <div className="mb-2 mb-sm-5">
              <div className="d-flex align-items-center justify-content-between mb-3 mt-3">
                <h1 className="page-heading-title mb-0">LABELS</h1>
                {userCan("fm_label_create") ? (
                  <div className="me-3">
                    <Link to="/fm-labels/create" className="fu-btn fu-btn-gray">
                      <span className="btn-bg"></span>
                      Create New
                    </Link>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="mt-4">
                <LabelsFiltration getLabels={getLabels} perPage={perPage} orderBy={orderBy} orderType={orderType} />
              </div>
            </div>
            <div className="row py-3 d-none d-xxl-flex table-heading-brdr">
              <div className="col-md-1">
                <h3 className="h6 mb-0 fu-text-white">#ID</h3>
              </div>
              <div className="col-md-4">
                <h3 className="h6 mb-0 fu-text-white">KEY</h3>
              </div>
              <div className="col-md-3">
                <h3 className="h6 mb-0 fu-text-white">LABEL NAME</h3>
              </div>
              <div className="col-md-4">
                <h3 className="h6 mb-0 fu-text-white">OPERATIONS</h3>
              </div>
            </div>
            <div className="table-heading-brdr mt-4 mt-sm-0 d-xxl-none"></div>
            {isPaginateLoading ? (
              <div className="d-flex justify-content-center mt-5">
                <div className="position-relative mt-5">
                  <LoadingCircle circleCont={85} icon={80} loader={85} dot={85} />
                </div>
              </div>
            ) : (
              <>
                {labels.data && labels.data.length > 0 ? (
                  labels.data.map((label, index) => <LabelRow key={index} meta={labels.meta} label={label} index={index} getLabels={getLabels} perPage={perPage} pageNum={pageNum} orderBy={orderBy} orderType={orderType} />)
                ) : labels.data && labels.data.length === 0 && filtrationDetails.search_query === "" && filtrationDetails.only_trashed === 0 && !isFiltrationLoading ? (
                  <div className="d-flex flex-column justify-content-center align-items-center mt-5 pt-5 item-msg">
                    <div>
                      <h2 className="fu-text-3-rem fu-text-yellow">
                        <i className="bi bi-database-add"></i>
                      </h2>
                    </div>
                    <div>
                      <h3 className="h5 fu-text-light-gray">
                        There Are No labels
                        {userCan("fm_label_create") ? (
                          <>
                            ,
                            <Link to="/fm-labels/create" className="link-dashed ms-2">
                              Create New
                            </Link>
                          </>
                        ) : (
                          ""
                        )}
                      </h3>
                    </div>
                  </div>
                ) : !isFiltrationLoading ? (
                  <div className="d-flex flex-column justify-content-center align-items-center mt-5 pt-5 item-msg">
                    <div>
                      <h2 className="fu-text-3-rem fu-text-yellow">
                        <i className="bi bi-search"></i>
                      </h2>
                    </div>
                    <div>
                      <h3 className="h5 fu-text-light-gray">There are no labels matching your search</h3>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="mt-5">{labels ? labels.meta && labels.meta.last_page !== 1 ? <Pagination pages={labels.meta.links} pagination={labels.meta} getItems={getLabels} pathName={"fm-labels"} filtrationDetails={filtrationDetails} setIsPaginateLoading={setIsPaginateLoading} setPageNum={setPageNum} per_page={perPage} order_by={orderBy} order_type={orderType} /> : "" : ""}</div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Labels;
